import { createStore, createEvent } from 'effector';
import {
  ContextMenuItemData,
  UiContextMenuState,
  UiContextMenuSubX as SubX,
  UiContextMenuSubY as SubY,
  UiContextMenuTheme,
  UiContextMenuConfig,
} from '@nx-frontend/shared/types';

const initialContextMenu: UiContextMenuState = {
  isShown: false,
  items: [],
  position: { x: 0, y: 0, subX: SubX.TOP, subY: SubY.LEFT },
  config: {},
  themeClassesMenu: undefined,
  themeClassesItem: undefined,
  usePopperSubmenu: undefined,
};

export interface OpenContextMenuEventParams {
  items: ContextMenuItemData[];
  themeClassesMenu?: string;
  themeClassesItem?: string;
  position: { x: number; y: number; subX: SubX; subY: SubY };
  config?: UiContextMenuConfig;
  additionalStyles?: string;
  zIndex?: number;
  usePopperSubmenu?: boolean;
}

// Create events for opening and closing the context menu
export const openContextMenuEvent = createEvent<OpenContextMenuEventParams>();

export const closeContextMenuEvent = createEvent();

// Create an event for setting the context menu theme
export const setContextMenuThemeEvent = createEvent<UiContextMenuTheme>();

// Create a store to store the state of the context menu
export const $contextMenuStore = createStore(initialContextMenu)
  .reset(closeContextMenuEvent)
  .on(
    openContextMenuEvent,
    (
      state,
      {
        items,
        position,
        config,
        additionalStyles,
        zIndex,
        themeClassesMenu = undefined,
        themeClassesItem = undefined,
        usePopperSubmenu = undefined,
      }
    ) => {
      return {
        ...state,
        isShown: true,
        items,
        position,
        additionalStyles: additionalStyles ?? '',
        zIndex,
        themeClassesMenu,
        themeClassesItem,
        ...(config ? { config } : {}),
        usePopperSubmenu,
      };
    }
  )
  .on(setContextMenuThemeEvent, (state, theme) => {
    return {
      ...state,
      config: {
        ...state.config,
        theme,
      },
    };
  });

export const $isShownContextMenu = $contextMenuStore.map((state) => state.isShown);
export const $positionContextMenu = $contextMenuStore.map((state) => state.position);
export const $contextThemeClassesMenu = $contextMenuStore.map((state) => state.themeClassesMenu);
export const $contextThemeClassesItem = $contextMenuStore.map((state) => state.themeClassesItem);
export const $theme = $contextMenuStore.map((state) => state.config?.theme || UiContextMenuTheme.LIGHT);
